import React from "react";

export const ShieldCheckIcon = ({ className = "w-5 h-5", fill = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path
      fill={fill}
      d="M12 2 4 5v6c0 5 3.4 9.5 8 11 4.6-1.5 8-6 8-11V5l-8-3Zm-1.1 14.3-3.7-3.7 1.4-1.4 2.3 2.3 5-5 1.4 1.4-6.4 6.4Z"
    />
  </svg>
);

export const UsersIcon = ({ className = "w-3.5 h-3.5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 19c.6-3 3.4-4.5 6.5-4.5s5.9 1.5 6.5 4.5" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M16 15c2.5 0 4.6 1.1 5.5 3" />
  </svg>
);

export const InvitePeopleIcon = ({ className = "w-5 h-5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="9" cy="8" r="3.2" />
    <path d="M2.5 19c.6-3 3.4-4.5 6.5-4.5s5.9 1.5 6.5 4.5" />
    <path d="M18 7v6M15 10h6" strokeLinecap="round" />
  </svg>
);

export const ClockIcon = ({ className = "w-3.5 h-3.5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" strokeLinecap="round" />
  </svg>
);

export const TrophyIcon = ({ className = "w-20 h-20" }) => (
  <svg viewBox="0 0 96 96" className={className} fill="none" aria-hidden="true">
    <path
      d="M30 18h36v10c0 12-8 22-18 22S30 40 30 28V18Z"
      stroke="#0F4146"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <path
      d="M30 22H22c0 8 4 14 10 16M66 22h8c0 8-4 14-10 16"
      stroke="#0F4146"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path d="M48 50v10" stroke="#0F4146" strokeWidth="2.5" strokeLinecap="round" />
    <rect x="36" y="60" width="24" height="6" rx="1.5" stroke="#0F4146" strokeWidth="2.5" />
    <rect x="30" y="66" width="36" height="8" rx="1.5" stroke="#0F4146" strokeWidth="2.5" />
    <g stroke="#0F4146" strokeWidth="2" strokeLinecap="round">
      <path d="M14 14l4 4M82 14l-4 4M12 36h4M80 36h-4" />
    </g>
    <g fill="#0F4146" opacity="0.55">
      <circle cx="16" cy="56" r="1.5" />
      <circle cx="80" cy="58" r="1.5" />
      <circle cx="22" cy="74" r="1.2" />
      <circle cx="76" cy="76" r="1.2" />
    </g>
  </svg>
);

export const ChevronRightIcon = ({ className = "w-5 h-5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="2" aria-hidden="true">
    <path d="m9 6 6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const GlobeIcon = ({ className = "w-10 h-10", stroke = "#004C50" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="24" cy="24" r="18" />
    <ellipse cx="24" cy="24" rx="9" ry="18" />
    <path d="M6 24h36M9 14h30M9 34h30" strokeLinecap="round" />
  </svg>
);

export const TrendUpIcon = ({ className = "w-10 h-10", stroke = "#004C50" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" stroke={stroke} strokeWidth="2" aria-hidden="true">
    <path d="M8 32l10-10 6 6 14-14M28 14h12v12" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// NOTE: the hand-drawn USF / UT shields that used to live here are gone. Club
// crests are real artwork now — see ClubShield.jsx + public/league-clubs/. Do
// not re-add a drawn university mark: the drawn UT shield is what once rendered
// reversed as "TU".

export const CrownIcon = ({ className = "w-3.5 h-3.5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <path d="M3 18h18M5 18l-1-10 5 4 3-6 3 6 5-4-1 10" strokeLinejoin="round" />
  </svg>
);

export const CreateLeagueIcon = ({ className = "w-5 h-5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="9" cy="8" r="3.3" />
    <path d="M2.5 19c.6-3 3.4-4.5 6.5-4.5s5.9 1.5 6.5 4.5" />
    <circle cx="17.5" cy="9" r="2.5" />
    <path d="M16 14.5c2.5 0 4.5 1.2 5.5 3" />
  </svg>
);

export const ArrowLeftIcon = ({ className = "w-5 h-5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="2" aria-hidden="true">
    <path d="M15 6 9 12l6 6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CheckIcon = ({ className = "w-3.5 h-3.5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="2.5" aria-hidden="true">
    <path d="m5 12 5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// The league-reward medal — same geometry as the Medal.svg the old League Play
// cards use, inlined so it can be recoloured (an <img> can't). Defaults to the
// dark teal the Create League button is painted in.
export const MedalIcon = ({ className = "w-[18px] h-[18px]", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 17 17" className={className} fill="none" stroke={stroke} strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M8.30724 11.4231C11.1749 11.4231 13.4995 9.09839 13.4995 6.23076C13.4995 3.36313 11.1749 1.03845 8.30724 1.03845C5.4396 1.03845 3.11493 3.36313 3.11493 6.23076C3.11493 9.09839 5.4396 11.4231 8.30724 11.4231Z" />
    <path d="M8.30722 9.34613C10.0278 9.34613 11.4226 7.95132 11.4226 6.23074C11.4226 4.51016 10.0278 3.11536 8.30722 3.11536C6.58664 3.11536 5.19183 4.51016 5.19183 6.23074C5.19183 7.95132 6.58664 9.34613 8.30722 9.34613Z" />
    <path d="M11.423 10.3843V15.5769L8.30713 14.0192L5.1922 15.5769V10.3847" />
  </svg>
);

export const EyeIcon = ({ className = "w-4 h-4", stroke = "#0F172A" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.7" aria-hidden="true">
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const EyeOffIcon = ({ className = "w-4 h-4", stroke = "#0F172A" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.7" aria-hidden="true">
    <path d="M4 5l16 14" strokeLinecap="round" />
    <path d="M9.5 6a9.6 9.6 0 0 1 2.5-.3c6 0 9.5 6.3 9.5 6.3a17 17 0 0 1-2.4 3.1M6.4 8A17 17 0 0 0 2.5 12S6 18.3 12 18.3c1 0 2-.2 2.8-.5" strokeLinecap="round" />
    <path d="M10 10.2a3 3 0 0 0 4 4.2" strokeLinecap="round" />
  </svg>
);

export const PlusIcon = ({ className = "w-5 h-5", stroke = "#6B7280" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <path d="M12 5v14M5 12h14" strokeLinecap="round" />
  </svg>
);

export const CashIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.7" aria-hidden="true">
    <rect x="2.5" y="6" width="19" height="12" rx="2" />
    <circle cx="12" cy="12" r="2.6" />
    <path d="M6 9.5v5M18 9.5v5" strokeLinecap="round" />
  </svg>
);

export const CopyIcon = ({ className = "w-4 h-4", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M15 5.5A1.5 1.5 0 0 0 13.5 4h-8A1.5 1.5 0 0 0 4 5.5v8A1.5 1.5 0 0 0 5.5 15" strokeLinecap="round" />
  </svg>
);

export const SearchIcon = ({ className = "w-4 h-4", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="2" aria-hidden="true">
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" strokeLinecap="round" />
  </svg>
);

// Sliders, not a gear — the Settings step is a set of switches, and the design
// uses the "tune" glyph for it.
export const SlidersIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.7" aria-hidden="true">
    <path d="M4 7h10M18 7h2M4 12h4M12 12h8M4 17h10M18 17h2" strokeLinecap="round" />
    <circle cx="16" cy="7" r="2" />
    <circle cx="10" cy="12" r="2" />
    <circle cx="16" cy="17" r="2" />
  </svg>
);

export const InfoCircleIcon = ({ className = "w-4 h-4", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5" strokeLinecap="round" />
    <circle cx="12" cy="8" r="0.9" fill={stroke} stroke="none" />
  </svg>
);

export const TrophyOutlineIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <path d="M10 5h12v6c0 4.4-2.7 8-6 8s-6-3.6-6-8V5Z" strokeLinejoin="round" />
    <path d="M10 7H6c0 3.5 1.8 6 5 7M22 7h4c0 3.5-1.8 6-5 7" strokeLinecap="round" />
    <path d="M16 19v4" strokeLinecap="round" />
    <rect x="12" y="23" width="8" height="2.5" rx="0.6" />
    <rect x="10" y="25.5" width="12" height="3" rx="0.6" />
  </svg>
);

export const CandlestickIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <path d="M8 4v6M8 22v6M16 6v4M16 22v4M24 2v8M24 22v8" strokeLinecap="round" />
    <rect x="6" y="10" width="4" height="12" rx="0.8" />
    <rect x="14" y="10" width="4" height="12" rx="0.8" />
    <rect x="22" y="10" width="4" height="12" rx="0.8" />
  </svg>
);

export const GradCapIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <path d="M2 13 16 7l14 6-14 6L2 13Z" strokeLinejoin="round" fill="#0F4146" />
    <path d="M8 16v6c0 1.5 3.6 3 8 3s8-1.5 8-3v-6" />
    <path d="M28 14v6" strokeLinecap="round" />
  </svg>
);

export const ShieldOutlineIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <path d="M16 3 5 6v10c0 6.5 4.4 10.8 11 13 6.6-2.2 11-6.5 11-13V6L16 3Z" strokeLinejoin="round" />
  </svg>
);

export const StocksIcon = ({ className = "w-9 h-9", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 40 40" className={className} fill="none" stroke={stroke} strokeWidth="2" aria-hidden="true">
    <path d="M6 32V20M12 32V14M18 32V18M24 32V10M30 32V14" strokeLinecap="round" />
    <path d="M6 18l6-6 6 4 6-10 6 6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m30 8 4-2-1 4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CryptoIcon = ({ className = "w-9 h-9", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 40 40" className={className} fill="none" stroke={stroke} strokeWidth="2" aria-hidden="true">
    <circle cx="20" cy="20" r="14" />
    <path d="M15 11v18M19 11v18" strokeLinecap="round" />
    <path d="M13 13h10a3 3 0 0 1 0 6H13M13 19h11a3 3 0 0 1 0 6H13" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ForexIcon = ({ className = "w-9 h-9", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 40 40" className={className} fill="none" stroke={stroke} strokeWidth="2" aria-hidden="true">
    <circle cx="13" cy="14" r="6" />
    <circle cx="27" cy="26" r="6" />
    <text x="13" y="18" fontSize="9" fontFamily="Inter, sans-serif" fontWeight="600" textAnchor="middle" fill={stroke} stroke="none">$</text>
    <text x="27" y="30" fontSize="9" fontFamily="Inter, sans-serif" fontWeight="600" textAnchor="middle" fill={stroke} stroke="none">€</text>
    <path d="M20 14l4-4M22 10h2v2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 26l-4 4M18 30h-2v-2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PieMixedIcon = ({ className = "w-9 h-9", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 40 40" className={className} fill="none" stroke={stroke} strokeWidth="2" aria-hidden="true">
    <path d="M20 6v14h14A14 14 0 0 0 20 6Z" strokeLinejoin="round" />
    <path d="M20 34a14 14 0 1 1 0-28" strokeLinecap="round" />
  </svg>
);

export const CalendarIcon = ({ className = "w-5 h-5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <rect x="3.5" y="5" width="17" height="15" rx="2" />
    <path d="M8 3v4M16 3v4M3.5 10h17" strokeLinecap="round" />
  </svg>
);

export const QushiCoinIcon = ({ className = "w-12 h-12" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <circle cx="24" cy="24" r="20" stroke="#22A36B" strokeWidth="2" />
    <circle cx="24" cy="24" r="15" stroke="#22A36B" strokeWidth="2" />
    <circle cx="24" cy="24" r="10" stroke="#22A36B" strokeWidth="2" />
    <text
      x="24"
      y="29"
      fill="#0F4146"
      fontSize="14"
      fontWeight="700"
      textAnchor="middle"
      fontFamily="Inter, sans-serif"
    >
      Q
    </text>
  </svg>
);

export const SingleUserIcon = ({ className = "w-5 h-5", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="12" cy="9" r="3.5" />
    <path d="M5 20c.8-3.5 3.7-5.5 7-5.5s6.2 2 7 5.5" strokeLinecap="round" />
  </svg>
);

export const DoubleUserIcon = ({ className = "w-5 h-5", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="9" cy="9" r="3" />
    <path d="M3 20c.6-3 3-4.5 6-4.5s5.4 1.5 6 4.5" strokeLinecap="round" />
    <circle cx="17" cy="10" r="2.5" />
    <path d="M16 16c2.6 0 4.7 1.3 5.5 3.5" strokeLinecap="round" />
  </svg>
);

export const TripleUserIcon = ({ className = "w-5 h-5", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="12" cy="9" r="2.7" />
    <path d="M6.5 19c.5-2.7 2.7-4.2 5.5-4.2s5 1.5 5.5 4.2" strokeLinecap="round" />
    <circle cx="5" cy="10" r="2.2" />
    <circle cx="19" cy="10" r="2.2" />
    <path d="M1 19c.4-2 1.7-3 4-3.2M23 19c-.4-2-1.7-3-4-3.2" strokeLinecap="round" />
  </svg>
);

// One stylised QUSHi coin stack. Stack count comes from the parent.
const CoinStack = ({ x, height, fill = "#F6C744", stroke = "#B8860B" }) => {
  const layers = Math.max(1, Math.min(4, height));
  return (
    <g>
      {Array.from({ length: layers }).map((_, i) => (
        <ellipse
          key={i}
          cx={x}
          cy={26 - i * 3.5}
          rx="7"
          ry="2.2"
          fill={fill}
          stroke={stroke}
          strokeWidth="0.8"
        />
      ))}
      <rect
        x={x - 7}
        y={26 - layers * 3.5}
        width="14"
        height={layers * 3.5}
        fill={fill}
        opacity="0.55"
      />
      <text
        x={x}
        y={26 - layers * 3.5 + (layers * 3.5) / 2 + 1.5}
        fontSize="5"
        fontFamily="Inter, sans-serif"
        fontWeight="700"
        fill={stroke}
        textAnchor="middle"
      >
        Q
      </text>
    </g>
  );
};

export const CoinStackIcon = ({ stacks = 1, className = "w-10 h-7" }) => {
  // Tier 1 = 1 stack (3 coins), Tier 2 = 2 stacks (3,4 coins), Tier 3 = 3 stacks (3,4,5 coins)
  const safe = Math.max(0, Math.min(3, stacks));
  const positions = [];
  if (safe >= 1) positions.push({ x: 11, height: 3 });
  if (safe >= 2) positions.push({ x: 22, height: 4 });
  if (safe >= 3) positions.push({ x: 33, height: 5 });
  return (
    <svg viewBox="0 0 44 32" className={className} aria-hidden="true">
      {safe === 0 ? (
        <g opacity="0.35">
          <CoinStack x={22} height={1} fill="#D1D5DB" stroke="#6B7280" />
        </g>
      ) : (
        positions.map((p) => <CoinStack key={p.x} x={p.x} height={p.height} />)
      )}
    </svg>
  );
};

export const ClipboardIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <rect x="7" y="6" width="18" height="22" rx="2" />
    <rect x="11" y="3" width="10" height="5" rx="1.2" fill="#0F4146" />
    <path d="M11 14h10M11 18h10M11 22h6" strokeLinecap="round" />
  </svg>
);

export const PrivateUsersIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="12" cy="11" r="3.2" />
    <path d="M5 22c.7-3.2 3.6-5 7-5s6.3 1.8 7 5" />
    <circle cx="22.5" cy="13" r="2.5" />
    <path d="M21.5 19c2.4 0 4.5 1.2 5.5 3" />
    <rect x="19" y="20" width="8" height="6" rx="1.3" fill="#22A36B" stroke="#22A36B" />
    <path d="M21 20v-1.5a2 2 0 0 1 4 0V20" stroke="#22A36B" />
    <rect x="22.5" y="22" width="1.6" height="2.6" rx="0.4" fill="#FFFFFF" stroke="#FFFFFF" />
  </svg>
);

export const LinkChainIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <path d="M13 19a4 4 0 0 1 0-6l3-3a4 4 0 0 1 5.66 5.66l-1.5 1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19 13a4 4 0 0 1 0 6l-3 3a4 4 0 0 1-5.66-5.66l1.5-1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ShareUpIcon = ({ className = "w-5 h-5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <path d="M12 4v12M8 8l4-4 4 4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 14v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4" strokeLinecap="round" />
  </svg>
);

export const GoldShieldLockIcon = ({ className = "w-32 h-32" }) => (
  <svg viewBox="0 0 160 160" className={className} aria-hidden="true">
    <defs>
      <radialGradient id="goldRim" cx="50%" cy="20%" r="80%">
        <stop offset="0%" stopColor="#F8D77A" />
        <stop offset="55%" stopColor="#D9A646" />
        <stop offset="100%" stopColor="#8C6320" />
      </radialGradient>
      <linearGradient id="shieldBody" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#0F4146" />
        <stop offset="100%" stopColor="#062326" />
      </linearGradient>
      <radialGradient id="lockGloss" cx="30%" cy="25%" r="70%">
        <stop offset="0%" stopColor="#86F0A8" />
        <stop offset="100%" stopColor="#22A36B" />
      </radialGradient>
      <radialGradient id="haloGlow" cx="50%" cy="50%" r="55%">
        <stop offset="0%" stopColor="#86F0A8" stopOpacity="0.45" />
        <stop offset="100%" stopColor="#86F0A8" stopOpacity="0" />
      </radialGradient>
    </defs>

    <ellipse cx="80" cy="140" rx="48" ry="6" fill="url(#haloGlow)" />

    <path
      d="M80 14 24 30v40c0 28 22 48 56 60 34-12 56-32 56-60V30L80 14Z"
      fill="url(#goldRim)"
      stroke="#7A5417"
      strokeWidth="1.2"
    />
    <path
      d="M80 24 33 37v33c0 23 18 40 47 51 29-11 47-28 47-51V37L80 24Z"
      fill="url(#shieldBody)"
      stroke="#0A2A2D"
      strokeWidth="0.8"
    />

    <rect x="62" y="74" width="36" height="30" rx="4" fill="url(#lockGloss)" stroke="#0E7A4B" strokeWidth="1" />
    <path d="M68 74v-6a12 12 0 0 1 24 0v6" fill="none" stroke="url(#lockGloss)" strokeWidth="4" strokeLinecap="round" />
    <rect x="76" y="83" width="8" height="13" rx="1.5" fill="#062326" />

    <g fill="#FFE6A6">
      <path d="M126 30 l2-5 2 5 5 2-5 2-2 5-2-5-5-2z" />
      <path d="M34 110 l1.5-4 1.5 4 4 1.5-4 1.5-1.5 4-1.5-4-4-1.5z" />
      <circle cx="138" cy="64" r="1.6" />
      <circle cx="22" cy="56" r="1.4" />
      <circle cx="128" cy="98" r="1.6" />
    </g>
    <g fill="#A8E0BE">
      <circle cx="48" cy="34" r="1.4" />
      <circle cx="118" cy="120" r="1.6" />
    </g>
  </svg>
);

export const ShieldLockIcon = ({ className = "w-20 h-20" }) => (
  <svg viewBox="0 0 120 120" className={className} aria-hidden="true">
    <circle cx="60" cy="60" r="58" fill="#0B3A3F" />
    <path
      d="M60 28 36 36v22c0 14 10 24 24 28 14-4 24-14 24-28V36L60 28Z"
      fill="#0B3A3F"
      stroke="#E5E7EB"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <rect x="48" y="58" width="24" height="20" rx="3.5" fill="#22A36B" />
    <path
      d="M52 58v-4a8 8 0 0 1 16 0v4"
      fill="none"
      stroke="#22A36B"
      strokeWidth="3.5"
      strokeLinecap="round"
    />
    <rect x="58.5" y="64" width="3" height="8" rx="1" fill="#0B3A3F" />
  </svg>
);

export const SmallCalendarIcon = ({ className = "w-6 h-6", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <rect x="3.5" y="5" width="17" height="15" rx="2" />
    <path d="M8 3v4M16 3v4M3.5 10h17" strokeLinecap="round" />
  </svg>
);

export const SmallPieIcon = ({ className = "w-6 h-6", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <path d="M12 3v9h9A9 9 0 0 0 12 3Z" />
    <path d="M12 21a9 9 0 1 1 0-18" strokeLinecap="round" />
  </svg>
);

export const SmallUsersIcon = ({ className = "w-6 h-6", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="9" cy="9" r="3" />
    <path d="M3 19c.6-3 3-4.5 6-4.5s5.4 1.5 6 4.5" strokeLinecap="round" />
    <circle cx="17" cy="10" r="2.5" />
    <path d="M16 16c2.6 0 4.7 1.3 5.5 3.5" strokeLinecap="round" />
  </svg>
);

export const SmallUserIcon = ({ className = "w-6 h-6", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="12" cy="9" r="3.5" />
    <path d="M5 20c.8-3.5 3.7-5.5 7-5.5s6.2 2 7 5.5" strokeLinecap="round" />
  </svg>
);

export const SmallLockIcon = ({ className = "w-7 h-7", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" stroke={stroke} strokeWidth="2" aria-hidden="true">
    <rect x="9" y="14" width="14" height="12" rx="2.5" />
    <path d="M12 14v-3a4 4 0 0 1 8 0v3" strokeLinecap="round" />
  </svg>
);

export const SmallCheckCircleIcon = ({ className = "w-5 h-5", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <path d="m8 12 3 3 5-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const JoinedConfettiCheckIcon = ({ className = "w-44 h-44" }) => (
  <svg viewBox="0 0 200 200" className={className} aria-hidden="true">
    <g fill="#22A36B">
      <rect x="38" y="64" width="10" height="6" rx="1.5" transform="rotate(-20 43 67)" />
      <rect x="148" y="58" width="8" height="5" rx="1.2" transform="rotate(15 152 60)" />
      <rect x="160" y="92" width="9" height="5" rx="1.2" transform="rotate(40 164 94)" />
      <rect x="32" y="98" width="9" height="5" rx="1.2" transform="rotate(-30 36 100)" />
      <rect x="62" y="44" width="7" height="4" rx="1" transform="rotate(35 65 46)" />
      <rect x="128" y="48" width="6" height="4" rx="1" transform="rotate(-25 131 50)" />
      <circle cx="40" cy="120" r="3" />
      <circle cx="162" cy="124" r="3" />
      <circle cx="78" cy="50" r="2.5" />
      <circle cx="124" cy="62" r="2.2" />
    </g>
    <g fill="#A7E5C0">
      <rect x="46" y="80" width="8" height="5" rx="1.2" transform="rotate(40 50 82)" />
      <rect x="138" y="80" width="8" height="5" rx="1.2" transform="rotate(-40 142 82)" />
      <rect x="84" y="34" width="6" height="4" rx="1" />
      <rect x="110" y="34" width="6" height="4" rx="1" />
    </g>
    <circle cx="100" cy="100" r="46" fill="#E7F8EE" />
    <path
      d="M76 100l16 16 32-34"
      fill="none"
      stroke="#0F4146"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// The private-league mark the client supplied for this row — "Stitch is being a
// bitch and not putting the icon next to the private league button."
//
// Redrawn as a vector rather than dropping in the 1024px raster from Stitch: the
// icon renders at 32px, where a scaled-down render is mush, and QUSHi's UI uses
// real icons rather than mockup art. Same composition as the client's image — a
// ring, three figures with the middle one forward, and a shield carrying a
// padlock across the group.
export const PrivateLeagueMarkIcon = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <circle cx="16" cy="16" r="14.2" fill="none" stroke="#0F4146" strokeWidth="1.5" />
    {/* The two behind, held back in a quieter sage so the group reads as depth
        rather than three equal figures. */}
    <circle cx="9.6" cy="13.2" r="2.1" fill="#8FB3AC" />
    <path d="M6.2 21.8v-2.1a3.4 3.4 0 0 1 6.8 0v2.1z" fill="#8FB3AC" />
    <circle cx="22.4" cy="13.2" r="2.1" fill="#8FB3AC" />
    <path d="M19 21.8v-2.1a3.4 3.4 0 0 1 6.8 0v2.1z" fill="#8FB3AC" />
    <circle cx="16" cy="11.5" r="2.8" fill="#2F7A72" />
    <path d="M11.2 21.8v-2.4a4.8 4.8 0 0 1 9.6 0v2.4z" fill="#2F7A72" />
    {/* The shield sits across the group, which is the whole point of the mark. */}
    <path
      d="M16 17.2l4.5 1.6v3.1c0 2.6-1.8 4.8-4.5 5.8-2.7-1-4.5-3.2-4.5-5.8v-3.1z"
      fill="#0F4146"
    />
    <rect x="14.75" y="22.1" width="2.5" height="2.6" rx="0.5" fill="#FFFFFF" />
    <path
      d="M15 22.1v-.9a1 1 0 0 1 2 0v.9"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="0.8"
    />
  </svg>
);

export const PrivateLeagueCelebrationIcon = ({ className = "w-44 h-44" }) => (
  <svg viewBox="0 0 200 200" className={className} aria-hidden="true">
    <circle cx="100" cy="100" r="86" fill="#E7F8EE" />
    <g fill="none" stroke="#0F4146" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="100" cy="76" r="14" />
      <path d="M70 132c2-14 14-22 30-22s28 8 30 22" />
      <circle cx="62" cy="86" r="11" />
      <path d="M44 132c2-10 10-16 18-17" />
      <circle cx="138" cy="86" r="11" />
      <path d="M156 132c-2-10-10-16-18-17" />
      <path d="M80 130 L80 150 Q80 170 100 178 Q120 170 120 150 L120 130 Z" fill="#FFFFFF" />
      <path d="M88 148l8 8 16-16" stroke="#22A36B" strokeWidth="4" />
    </g>
    <g fill="#22A36B">
      <circle cx="48" cy="58" r="2.5" />
      <circle cx="156" cy="48" r="2" />
      <circle cx="170" cy="118" r="2.5" />
      <circle cx="36" cy="120" r="2" />
      <path d="M58 38 l3-6 3 6 6 3-6 3-3 6-3-6-6-3z" />
      <path d="M150 152 l2.5-5 2.5 5 5 2.5-5 2.5-2.5 5-2.5-5-5-2.5z" />
    </g>
  </svg>
);

// ---------------------------------------------------------------------------
// League Play landing (redesign)
// ---------------------------------------------------------------------------

// "Live markets" — broadcast antenna. Green because it marks a live data feed.
export const BroadcastIcon = ({ className = "w-3.5 h-3.5", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="12" cy="12" r="2.2" fill={stroke} stroke="none" />
    <path d="M8.2 8.2a5.4 5.4 0 0 0 0 7.6M15.8 8.2a5.4 5.4 0 0 1 0 7.6" strokeLinecap="round" />
    <path d="M5.4 5.4a9.4 9.4 0 0 0 0 13.2M18.6 5.4a9.4 9.4 0 0 1 0 13.2" strokeLinecap="round" />
  </svg>
);

// "Real prizes" / prize pool — small solid-cup trophy. Sized for meta rows and
// the prize-pool tile, so it reads at 14–28px.
export const PrizeTrophyIcon = ({ className = "w-3.5 h-3.5", fill = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path
      fill={fill}
      d="M7 3h10v2h3v3a4 4 0 0 1-4 4h-.5A5 5 0 0 1 13 14.9V17h3v2H8v-2h3v-2.1A5 5 0 0 1 8.5 12H8a4 4 0 0 1-4-4V5h3V3Zm0 4H6v1a2 2 0 0 0 1 1.7V7Zm10 0v2.7A2 2 0 0 0 18 8V7h-1ZM6 21h12v2H6v-2Z"
    />
  </svg>
);

// Organizer avatar placeholder. Only used when a league organizer has no
// profile picture — never as a decorative person glyph.
// A circle with a line through it — "not allowed". Used on the rules list of a
// league's join screen, where the value it labels is a flat no.
// The ENDS half of a schedule pair, drawn to sit beside ClockIcon: the same
// circle at the same 1.8 stroke, with a stop square where the clock has hands.
//
// Client: "use the same color, weight, and circle start and end glyphs as public
// leagues." Public leagues already mark STARTS with the circular ClockIcon, so
// this is its companion rather than a new family.
//
// A finish flag was drawn first and rejected on the screen: at 16px the pole and
// pennant close up into what reads as a letter P in a circle. A square has no
// interior detail to lose, so it survives the size, and stop/end is the one
// meaning it can carry. The app's other end marker (CalendarCheckIcon on the Cash
// Game rules grid) is a square calendar, which would break the circle, and a
// circled check would collide with the green check rows directly beneath this
// block on the Private League card.
export const StopCircleIcon = ({ className = "w-4 h-4", stroke = "#9CA3AF" }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    stroke={stroke}
    strokeWidth="1.8"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <rect x="8.9" y="8.9" width="6.2" height="6.2" rx="1.2" />
  </svg>
);

export const NoEntryIcon = ({ className = "w-4 h-4", stroke = "#9CA3AF" }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    stroke={stroke}
    strokeWidth="1.7"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="8.5" />
    <path d="M6 18 18 6" />
  </svg>
);

// Three ascending bars — a leaderboard, as a glyph rather than a chart.
export const BarsIcon = ({ className = "w-6 h-6", stroke = "#0F4146" }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    stroke={stroke}
    strokeWidth="1.8"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M5 20V13M12 20V5M19 20v-9" />
  </svg>
);

export const AvatarPersonIcon = ({ className = "w-4 h-4", stroke = "#9CA3AF" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <circle cx="12" cy="8.5" r="3.5" />
    <path d="M4.5 20c.8-3.6 3.9-5.5 7.5-5.5s6.7 1.9 7.5 5.5" strokeLinecap="round" />
  </svg>
);

// ---------------------------------------------------------------------------
// League icon picker (Create League, step 1)
// ---------------------------------------------------------------------------
// The four options the design offers. Each one has a matching 96×96 file in
// public/league-icons/<key>.svg — that file is what gets rasterised and uploaded
// as the league's image on submit, so a new option here needs a new SVG there
// (and an entry in LeagueIcon.jsx + VALID_ICON_KEYS in leagueImage.js).
// Placeholders by intent: better icon art is a round-two decision.

// "group" — a club or friend group.
export const PeopleGroupIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 96 96" className={className} fill="none" stroke={stroke} strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="48" cy="36" r="11" />
    <path d="M28 74c2.5-11 10.5-17 20-17s17.5 6 20 17" />
    <circle cx="22" cy="42" r="8" />
    <path d="M8 70c1.8-8 6.5-12.5 13-13.5" />
    <circle cx="74" cy="42" r="8" />
    <path d="M88 70c-1.8-8-6.5-12.5-13-13.5" />
  </svg>
);

// "chart" — markets. A framed chart, not the bare trend line (that's `trend`,
// which older leagues still use).
export const ChartFrameIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 96 96" className={className} fill="none" stroke={stroke} strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="14" y="18" width="68" height="60" rx="8" />
    <polyline points="26,62 40,48 50,56 70,34" />
    <polyline points="70,44 70,34 60,34" />
  </svg>
);

// "network" — a wider community. Deliberately more wireframe than GlobeIcon so
// the two read differently side by side in the picker.
export const NetworkGlobeIcon = ({ className = "w-7 h-7", stroke = "#0F4146" }) => (
  <svg viewBox="0 0 96 96" className={className} fill="none" stroke={stroke} strokeWidth="3" strokeLinecap="round" aria-hidden="true">
    <g transform="translate(48 48)">
      <circle r="30" />
      <ellipse rx="12" ry="30" />
      <ellipse rx="24" ry="30" />
      <line x1="-30" y1="0" x2="30" y2="0" />
      <line x1="-27" y1="-15" x2="27" y2="-15" />
      <line x1="-27" y1="15" x2="27" y2="15" />
    </g>
  </svg>
);

// ── Cash Game landing page ────────────────────────────────────────────────
// The Contest Rules grid pairs each rule with a glyph. Three of the design's
// icons had no equivalent in this set, so they are drawn here in the SAME
// geometry as the rest of it — a 24 viewBox, 1.8 stroke, round caps — rather
// than pulled from another family, which is the exact complaint the client
// raised about "Learn by doing" on the public league card.

// A calendar with a tick: the END of a run, against SmallCalendarIcon's plain
// calendar for the start. The design uses `event_available` for the same reason.
export const CalendarCheckIcon = ({ className = "w-6 h-6", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" aria-hidden="true">
    <rect x="3.5" y="5" width="17" height="15" rx="2" />
    <path d="M8 3v4M16 3v4M3.5 10h17" strokeLinecap="round" />
    <path d="M9 14.5l2.2 2.2L15.5 12.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Two opposed arrows — trades going both ways, for TRADE LIMIT. The design's
// `swap_horiz`.
export const SwapArrowsIcon = ({ className = "w-6 h-6", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 9h13M14 6l3 3-3 3" />
    <path d="M20 15H7M10 12l-3 3 3 3" />
  </svg>
);

// Arrows up and down through one stem — long AND short. The ALLOWED POSITIONS
// glyph in the client's Cash Game landing design, drawn at the same 1.8 stroke
// and round joins as the rest of this family so it does not read as an icon
// borrowed from somewhere else.
//
// On the CASH GAME landing page this is ALLOWED POSITIONS, and there it is
// deliberately not SwapArrowsIcon, which means TRADE LIMIT two cells away in the
// same grid — one mark cannot stand for two different facts on one card.
//
// On the PUBLIC and PRIVATE league landing pages it IS Trade limit, at the
// client's request ("replace the current glyph with an up and down arrow,
// similar to the Buy ticket icon we use on mobile"). Those cards have no
// allowed-positions row, so the two uses never meet on one screen.
export const UpDownArrowsIcon = ({ className = "w-6 h-6", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m7 10 5-5 5 5" />
    <path d="M12 5v14" />
    <path d="m17 14-5 5-5-5" />
  </svg>
);

// A target — skill, not chance. The design's `gps_fixed`, used on the benefit
// strip's SKILL BASED cell.
export const TargetIcon = ({ className = "w-6 h-6", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="12" cy="12" r="1" fill={stroke} stroke="none" />
  </svg>
);

// A dollar sign inside a circle — the design's STARTING CASH glyph (`paid`).
//
// That cell used CashIcon, which is the banknote QUSHi already uses for FREE TO
// ENTER on the benefit strip and again on the Enter Free button. At 18px inside
// the rules grid the note's inner circle and side bars collapse into a shape
// that reads as a wallet, and the same mark appearing three times on one screen
// stopped it meaning anything in particular. The design draws this one as a
// coin, so this is the coin.
export const DollarCircleIcon = ({ className = "w-6 h-6", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 6.4v1.5M12 16.1v1.5" />
    <path d="M14.3 9.5c-.4-.9-1.2-1.4-2.3-1.4-1.3 0-2.3.7-2.3 1.8 0 1.2 1 1.7 2.3 2 1.3.3 2.3.8 2.3 2 0 1.1-1 1.9-2.3 1.9-1.1 0-1.9-.5-2.3-1.4" />
  </svg>
);

// Bars inside a frame — Material's `analytics`, which is the glyph the client's
// design sets on the Contest Rules TRADING RULES row (`insert_chart` in their
// desktop file, the same bar chart).
//
// That row used ChartFrameIcon, a framed ASCENDING LINE. A line going up is a
// return, and this page already says that twice — TrendUpIcon on Eligible
// Assets and the same rising line here — so the icon that should mean "how you
// are allowed to trade" was reading as "performance". Bars are what the design
// draws and they are the reason it does not have that collision.
export const AnalyticsIcon = ({ className = "w-6 h-6", stroke = "#22A36B" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
    <path d="M8 16.5V13M12 16.5V8M16 16.5v-5.5" />
  </svg>
);

// A left arrow with a shaft — Material's `arrow_back`, which is the glyph the
// desktop design puts beside "All Contests". Not `ArrowLeftIcon`: that one is a
// bare chevron despite its name, and it is used across the app where a chevron
// is what is wanted, so it is left alone.
export const BackArrowIcon = ({ className = "w-5 h-5", stroke = "currentColor" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M19 12H5" />
    <path d="m11 18-6-6 6-6" />
  </svg>
);
